import { useLang } from '../LangContext';

// 9 unique cards — 3 columns x 3 cards each
// None of these images are used anywhere else in the site
const col1 = [
  { src: '/gallery/student1.jpg', label: 'Little Champ' },
  { src: '/gallery/student2.jpg', label: 'Representation' },
  { src: '/gallery/student3.jpg', label: 'Creativity' },
];
const col2 = [
  { src: '/gallery/gallary.webp', label: 'Birthday Celibration' },
  { src: '/gallery/lunch.webp', label: 'Lunch Time' },
  { src: '/gallery/tree.jpg', label: 'Learning' },
];
const col3 = [
  { src: '/gallery/art.jpg', label: 'Art & Craft' },
  { src: '/gallery/art2.jpg', label: 'Creative Fun' },
  { src: '/gallery/participate.webp', label: 'Activities' },
];

function ScrollColumn({ cards, direction }) {
  const doubled = [...cards, ...cards];
  return (
    <div className={`kph-scroll-col kph-scroll-col--${direction}`}>
      {doubled.map((card, i) => (
        <div className="kph-card" key={i}>
          <div className="kph-card-img">
            <img src={card.src} alt={card.label} loading="lazy" />
          </div>
          <div className="kph-card-label">{card.label}</div>
        </div>
      ))}
    </div>
  );
}

export default function Hero() {
  const { t } = useLang();
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section id="home" className="hero">
      <div className="hero-content">
        <div className="hero-badge">{t.heroBadge}</div>
        <h1>
          {t.heroH1a} <span className="highlight-orange">{t.heroStar}</span><br />
          {t.heroH1b} <span className="highlight-pink">{t.heroShine}</span><br />
          {t.heroH1c}
        </h1>
        <p>{t.heroP}</p>
        <div className="hero-btns">
          <button className="btn-primary" onClick={() => scrollTo('contact')}>{t.heroCTA}</button>
          <button className="btn-secondary" onClick={() => scrollTo('programs')}>{t.heroExplore}</button>
        </div>
        <div className="hero-stats">
          <div className="hero-stat"><strong>50+</strong><span>{t.heroStat1}</span></div>
          <div className="hero-stat"><strong>6+</strong><span>{t.heroStat2}</span></div>
          <div className="hero-stat"><strong>4.7★</strong><span>{t.heroStat3}</span></div>
          <div className="hero-stat"><strong>2+</strong><span>{t.heroStat4}</span></div>
        </div>
      </div>

      {/* Scrolling card gallery */}
      <div className="hero-image">
        <div className="kph-gallery-wrap">
          <ScrollColumn cards={col1} direction="down" />
          <ScrollColumn cards={col2} direction="up" />
          <ScrollColumn cards={col3} direction="down" />
        </div>
      </div>
    </section>
  );
}
